class CollegeSystem {
  constructor() {
    console.log("初始化CollegeSystem-----------")
    this.CollegeSystemList = []
    this.collegelList = [] //学院列表整合数据
    this.majorList = [] //专业整合数据
    this.classesList = [] //班级整合数据
    this.collegelMajorList = [] //学院专业整合数据
    this.collegelMajorClassList = [] //学院专业班级整合数据
  }
  //获取学院专业班级列表
  getCollegeSystem (that, flag = false) {
    return new Promise((resolve, reject) => {
      let data = {}
      if (flag) {
        data.asd = false
      }//不加权限判断
      that.$API['getCollegeSystem'](data).then(
        res => {
          resolve(res)
        },
        err => { }
      )
    })
  }

  // 获取组织架构中的部门树
  getDeptTree (that) {
    return new Promise((resolve, reject) => {
      let data = {}
      that.$API['getDeptTree'](data).then(
        res => {
          resolve(res)
        },
        err => { }
      )
    })
  }

  //获取学院列表
  getCollegeList (that, tag) {
    return new Promise((resolve, reject) => {
      this.collegelList = []
      let data = {}
      that.$API['getStudentCollegeList'](data).then(
        res => {
          for (let i = 0; i < res.length; i++) {
            this.collegelList.push({
              label: res[i].facultyName,
              value: res[i].id,
            })
          }

          if (tag) {
            if (tag > 1) {
              let info = this.getMajorList(that, tag)
              resolve(info)
            } else {
              resolve(this.collegelList)
            }
          } else {
            resolve(this.collegelList)

          }
        },
        err => { }
      )
    })

  }

  //获取专业列表 处理成级联数据
  getMajorList (that, tag) {
    return new Promise((resolve, reject) => {
      this.collegelMajorList = []
      let data = {}
      that.$API['getStudentMajorList'](data).then(
        (res) => {
          for (let i = 0; i < res.length; i++) {
            this.majorList.push({
              label: res[i].majorName,
              value: res[i].id,
              facultyId: res[i].facultyId,
            })
          }

          if (tag) {
            if (tag > 2) {
              let info = this.getClassesList(that, tag)
              resolve(info)
            } else {
              //处理学院和专业的级联数据,若未查询学院则直接返回专业列表，不进行数据处理
              if (this.collegelList && this.collegelList.length > 0) {
                this.collegelMajorList = this.collegelList
                for (const c of this.collegelMajorList) {
                  c.children = []
                  for (const m of this.majorList) {
                    if (c.value == m.facultyId) {
                      c.children.push(m)
                    }
                  }
                }
                resolve(this.collegelMajorList)
              } else {
                resolve(this.majorList)
              }
            }
          } else {
            resolve(this.majorList)
          }
          // this.getClassesList()
        },
        (err) => { }
      )
    })




  }

  //获取班级列表 处理成级联数据
  getClassesList (that, tag) {
    return new Promise((resolve, reject) => {
      this.collegelMajorList = []
      let data = {}
      that.$API.getStudentClassesList(data).then(
        (res) => {
          for (let i = 0; i < res.length; i++) {
            this.classesList.push({
              label: res[i].className,
              value: res[i].id,
              majorId: res[i].majorId,
              facultyId: res[i].facultyId,
            })
          }
          if (tag == 3 && this.collegelList && this.collegelList.length > 0 && this.majorList && this.majorList.length > 0) {
            this.collegelMajorList = this.collegelList
            for (const c of this.collegelMajorList) {
              c.children = []
              for (const m of this.majorList) {
                if (c.value == m.facultyId) {
                  m.children = []
                  c.children.push(m)
                  for (const cl of this.classesList) {
                    if (cl.majorId == m.value) {
                      m.children.push(cl)
                    }
                  }
                }
              }
            }
            resolve(this.collegelMajorList)
          } else {
            resolve(this.classesList)
          }
        },
        (err) => { }
      )
    })

  }

  //获取学位列表
  getDegreeList () {
    return new Promise((resolve, reject) => {
      let data = {}
      this.$API.getStudentDegreeList(data).then(
        (res) => {
          console.log(res, '学位')
          // this.degreeList = res
          // let arr = []
          // this.degreeList.map((item) => {
          //   let info = {
          //     label: item.degreeName,
          //     value: item.id,
          //   }
          //   arr.push(info)
          // })
          // let data = {
          //   type: 'select',
          //   key: 'degreeId',
          //   width: '300',
          //   placeholder: '请选择学位',
          //   options: arr,
          // }
          // this.$set(this.searchParam.seniorModul, this.searchParam.seniorModul.length, data)
        },
        (err) => { }
      )
    })

  }
  //获取年级
  getGrade () {
    var date = new Date()
    let year = date.getFullYear()
    let gradeArr = []
    for (let i = 0; i < 12; i++) {
      let data = {
        label: year - i,
        value: year - i,
      }
      gradeArr.push(data)
    }
    return gradeArr
  }

}

export default CollegeSystem



// WEBPACK FOOTER //
// ./src/assets/js/collegeSystem/CollegeSystem.js